import React from "react";
const lessonSummary = (props) => {
  return (
    <React.Fragment>
      {/* <!-- lesson summary --> */}
      <div className="lesson-summary">
        {/* <!-- header --> */}
        <h4 className="py-3">Lesson Summary</h4>
        <div className="div">
          {/* <!--1st row--> */}
          <div className="flex-between-center data-row-div">
            <div>Lesson</div>
            <div className="item">Maths(GCSE)</div>
          </div>
          {/* <!--2nd row--> */}
          <div className="flex-between-center data-row-div">
            <div>Start Date</div>
            <div className="item">Mon 14 May (Weekly)</div>
          </div>
          {/* <!--3rd row--> */}
          <div className="flex-between-center data-row-div">
            <div>Frequency</div>
            <div className="item">Weekly(Every Monday)</div>
          </div>
          {/* <!--4th row--> */}
          <div className="flex-between-center data-row-div">
            <div>Location</div>
            <div className="item">Online classroom</div>
          </div>
          {/* <!--5th row--> */}
          <div className="flex-between-center data-row-div">
            <div>Confirmation Number</div>
            <div className="item">ASK893T6TJ</div>
          </div>
        </div>
      </div>
      {/* <!--end lesson summary--> */}
      <div className="potential-earnings lesson-summary">
        {/* header */}
        <h4 className="py-5 text-dark">Potential Earnings</h4>
        <div className="div">
          {/* <!--1st row--> */}
          <div className="flex-between-center data-row-div">
            <div>Estimated fee per lesson</div>
            <div className="item">£ 20.0</div>
          </div>
          {/* <!--2nd row--> */}
          <div className="flex-between-center data-row-div">
            <div>Service fee</div>
            <div className="item">£ 4.00</div>
          </div>
          {/* <!--3rd row--> */}
          <div className="flex-between-center data-row-div">
            <div>Total earning for each lesson</div>
            <div className="item">£ 16.0</div>
          </div>
          {/* <!--4th row--> */}
          <div className="flex-between-center data-row-div">
            <div>
              <a href="#" className="anchor py-3 grrentxt ">
              Report user
              </a>
            </div>
            <div class="item">&nbsp;</div>
          </div>
          {/* <!--5th row--> */}
          <div className="flex-between-center data-row-div">
            <div>
              <a href="#" className="anchor py-3 grrentxt ">
                Help
              </a>
            </div>
            <div class="item">&nbsp;</div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
export default lessonSummary;
